import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { ITokenService, SERVICE_TOKEN } from 'src/app/core/api/token/interface';

//auth関連のサービスを提供します。
@Injectable({providedIn: 'root'})
export class AuthService {
    constructor(
        @Inject(SERVICE_TOKEN) private tokenService: ITokenService,
    ) {}

    //アプリがもつデータを全て削除
    deleteAllLocalInfo(){
        // トークンを削除する
        this.tokenService.clear();
        // 簡易ログインフラグを削除する
        // localStorage.removeItem('_rememberMe');
    }
}